module.exports = "../../../../platform/assets/pageMainIcon/cd-common-other2.svg";